
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, VStack, Heading, Text, Button, Container, Flex } from '@chakra-ui/react'
import type { ErrorWithMessage } from '@/shared/types/error'

type ErrorDisplayProps = {
    error: ErrorWithMessage
    reset: () => void
}

export function ErrorDisplay({ error, reset }: ErrorDisplayProps) {
    const navigate = useNavigate()
    const isAuthError = error.statusCode === 401 || error.statusCode === 403

    useEffect(() => {
        // TODO: add a logging service
        // eslint-disable-next-line no-console
        console.error('Application error:', error)
    }, [error])

    return (
        <Flex
            minH="100vh"
            align="center"
            justify="center"
            bg={'gray.50'}
            p={{ base: 4, sm: 6, lg: 8 }}
        >
            <Container maxW="lg">
                <VStack spacing={8} align="stretch">
                    <Box textAlign="center">
                        <Heading
                            mt={6}
                            size="xl"
                            fontWeight="extrabold"
                            color={'gray.900'}
                        >
                            {error.statusCode === 404
                                ? 'Page Not Found'
                                : 'Something went wrong'}
                        </Heading>
                        <Text mt={2} color={'gray.600'}>
                            {error.message}
                        </Text>
                    </Box>

                    <VStack spacing={4} mt={8}>
                        {isAuthError ? (
                            <Button w="full" onClick={() => navigate('/login')}>
                                Go to Login
                            </Button>
                        ) : (
                            <Button w="full" onClick={reset} fontSize="sm">
                                Try Again
                            </Button>
                        )}

                        <Button
                            w="full"
                            variant="outline"
                            onClick={() => navigate('/')}
                        >
                            Return Home
                        </Button>
                    </VStack>
                </VStack>
            </Container>
        </Flex>
    )
}
